// default Data With Data
// export const defaultData = {
//   NavigationItems: {
//     value: [
//       {
//         fields: {
//           Label: {
//             value: 'office space',
//           },
//           id: 100001,
//           Title: {
//             value: 'offices title',
//           },
//           Description: {
//             value: 'office value',
//           },
//           FindOutMoreCta: {
//             value: {
//               href: 'office-space',
//               linktype: 'internal',
//               text: '',
//               anchor: '',
//               querystring: '',
//               target: '',
//               id: '',
//             },
//           },
//           IsSearchable: {
//             value: true,
//           },
//           QueryString: {
//             value: '',
//           },
//         },
//       },
//       {
//         fields: {
//           Label: {
//             value: 'Coworkings',
//           },
//           id: 100002,
//           Title: {
//             value: 'coworking title',
//           },
//           Description: {
//             value: 'coworking description',
//           },
//           FindOutMoreCta: {
//             value: {
//               href: 'coworking',
//               linktype: 'internal',
//               text: '',
//               anchor: '',
//               querystring: '',
//               target: '',
//               id: '',
//             },
//           },
//           IsSearchable: {
//             value: true,
//           },
//           QueryString: {
//             value: '/coworking',
//           },
//         },
//       },
//       {
//         fields: {
//           Label: {
//             value: 'Meeting Rooms',
//           },
//           id: 100003,
//           Title: {
//             value: 'meeting rooms title',
//           },
//           Description: {
//             value: 'meeting rooms description',
//           },
//           FindOutMoreCta: {
//             value: {
//               href: 'meeting-rooms',
//               linktype: 'internal',
//               text: '',
//               anchor: '',
//               querystring: '',
//               target: '',
//               id: '',
//             },
//           },
//           IsSearchable: {
//             value: true,
//           },
//           QueryString: {
//             value: '/meetingroom',
//           },
//         },
//       },
//       {
//         fields: {
//           Label: {
//             value: 'Virtual Office',
//           },
//           id: 100004,
//           Title: {
//             value: 'virtual office title',
//           },
//           Description: {
//             value: 'virtual office description',
//           },
//           FindOutMoreCta: {
//             value: {
//               href: 'virtual-office',
//               linktype: 'internal',
//               text: '',
//               anchor: '',
//               querystring: '',
//               target: '',
//               id: '',
//             },
//           },
//           IsSearchable: {
//             value: true,
//           },
//           QueryString: {
//             value: '/virtualoffice',
//           },
//         },
//       },
//       {
//         fields: {
//           Label: {
//             value: 'Membership',
//           },
//           id: 100005,
//           Title: {
//             value: 'memebership title',
//           },
//           Description: {
//             value: 'membership description',
//           },
//           FindOutMoreCta: {
//             value: {
//               href: 'membership',
//               linktype: 'internal',
//               text: '',
//               anchor: '',
//               querystring: '',
//               target: '',
//               id: '',
//             },
//           },
//           IsSearchable: {
//             value: false,
//           },
//           QueryString: {
//             value: '/membership',
//           },
//         },
//       },
//     ],
//   },
//   BottomRightLink1: {
//     value: {
//       href: 'http://regus.dev.local/en/article',
//       text: 'About Regus',
//       anchor: '',
//       linktype: 'internal',
//       class: '',
//       title: '',
//       target: '',
//       querystring: '',
//       id: '{013A808A-0DCB-42BD-B7FC-55A988887DA7}',
//     },
//   },
//   BottomRightLink2: {
//     value: {
//       href: 'https://myregus.com/#/account',
//       text: 'Log-in',
//       linktype: 'external',
//       url: 'https://myregus.com/#/account',
//       anchor: '',
//       target: '',
//     },
//   },
//   FirstTitle: {
//     value: ' Call Us',
//   },
//   FirstDescription: {
//     value:
//       'Our advisers can answer your questions and help you find the right workspace.',
//   },
//   SecondTitle: {
//     value: 'We’ll call you',
//   },
//   SecondDescription: {
//     value:
//       'Send us your details and one of our team will get back to you, usually within 24 hours.',
//   },
//   GetInTouchCTA: {
//     value: {
//       href: '',
//     },
//   },
//   WaysToWorkText: {
//     value: 'Ways To Work',
//   },
//   WaysToWorkText: {
//     value: '',
//   },
//   Membership: {
//     value: {
//       href: '',
//       linktype: '',
//       text: '',
//       anchor: '',
//       querystring: '',
//       target: '',
//       id: '',
//     },
//   },
//   PhoneNumber: {
//     value: '',
//   },
// };

// default Data Without Data
export const defaultData = {
  NavigationItems: {
    value: [
      {
        fields: {
          Label: {
            value: '',
          },
          id: 100001,
          Title: {
            value: '',
          },
          Description: {
            value: '',
          },
          FindOutMoreCta: {
            value: {
              href: '',
              linktype: '',
              text: '',
              anchor: '',
              querystring: '',
              target: '',
              id: '',
            },
          },
          IsSearchable: {
            value: true,
          },
          QueryString: {
            value: '',
          },
        },
      },
      {
        fields: {
          Label: {
            value: '',
          },
          id: 100002,
          Title: {
            value: '',
          },
          Description: {
            value: '',
          },
          FindOutMoreCta: {
            value: {
              href: '',
              linktype: '',
              text: '',
              anchor: '',
              querystring: '',
              target: '',
              id: '',
            },
          },
          IsSearchable: {
            value: true,
          },
          QueryString: {
            value: '',
          },
        },
      },
      {
        fields: {
          Label: {
            value: '',
          },
          id: 100003,
          Title: {
            value: '',
          },
          Description: {
            value: '',
          },
          FindOutMoreCta: {
            value: {
              href: '',
              linktype: '',
              text: '',
              anchor: '',
              querystring: '',
              target: '',
              id: '',
            },
          },
          IsSearchable: {
            value: true,
          },
          QueryString: {
            value: '',
          },
        },
      },
      {
        fields: {
          Label: {
            value: '',
          },
          id: 100004,
          Title: {
            value: '',
          },
          Description: {
            value: '',
          },
          FindOutMoreCta: {
            value: {
              href: '',
              linktype: '',
              text: '',
              anchor: '',
              querystring: '',
              target: '',
              id: '',
            },
          },
          IsSearchable: {
            value: true,
          },
          QueryString: {
            value: '',
          },
        },
      },
      {
        fields: {
          Label: {
            value: '',
          },
          id: 100005,
          Title: {
            value: '',
          },
          Description: {
            value: '',
          },
          FindOutMoreCta: {
            value: {
              href: '',
              linktype: '',
              text: '',
              anchor: '',
              querystring: '',
              target: '',
              id: '',
            },
          },
          IsSearchable: {
            value: false,
          },
          QueryString: {
            value: '',
          },
        },
      },
    ],
  },
  BottomRightLink1: {
    value: {
      href: '',
      text: '',
      anchor: '',
      linktype: '',
      class: '',
      title: '',
      target: '',
      querystring: '',
      id: '',
    },
  },
  BottomRightLink2: {
    value: {
      href: '',
      text: '',
      linktype: '',
      url: '',
      anchor: '',
      target: '',
    },
  },
  FirstTitle: {
    value: '',
  },
  FirstDescription: {
    value: '',
  },
  SecondTitle: {
    value: '',
  },
  SecondDescription: {
    value: '',
  },
  GetInTouchCTA: {
    value: {
      href: '',
    },
  },
  WaysToWorkText: {
    value: '',
  },
  Membership: {
    value: {
      href: '',
      linktype: '',
      text: '',
      anchor: '',
      querystring: '',
      target: '',
      id: '',
    },
  },
  PhoneNumber: {
    value: '',
  },
};
